export default {
    // IMPORTANTE: indicar en el api en la lista PUBLIC_FIELD_NAMES los parametros que se quieren obtener de manera publica, esto para evitar que se puedan obtener todos los parametros
    methods: {
      // esta funcion recibe un array de strings con los nombres de los parametros que se quieren obtener y devuelve un objeto con los valores de esos parametros
      async getPublicParams(names){
        let payload = {
          names: names
        }
        try{
          let response = await axios.post(`/api/v1/default-parameters/values`, payload);
          return response.data;
        }
        catch(e){
          this.warn(e);
          return null;
        }
      },
      // esta funcion recibe un string con el nombre del parametro que se quiere obtener y devuelve el valor de ese parametro
      async getPublicParam(name){
        let params = await this.getPublicParams([name]);
        return params ? params[name] : null;
      },
    }
  }